export var getDomain = function getDomain(hostname) {
  return hostname.slice(hostname.indexOf('.'));
};